// @flow

export function getFirstName(fullName: ?string): string {
  if (fullName && fullName.trim()) {
    const re = /^([\w]+)/;
    const result = re.exec(fullName.trim());
    if (result) return result[1];
  }

  return '';
}
